module.exports = __webpack_public_path__ + "img/timesheet_icon.618ed118.svg";